import React, {useContext, useEffect, useState} from 'react';
import * as PropTypes from 'prop-types';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

import { buyNowContext } from "../BuyNow";
import TotalPrice from "../common/TotalPrice";
import {useHideHeaderOnMobile, useViewport} from "../../utils/custom_hooks";
import HeaderCompanyLogo from "../../../common/HeaderCompanyLogo";
import {PRODUCT_CATEGORIES} from "../../../../constants";

const CheckoutHeader = ({ showOrderSummary, setShowOrderSummary }) => {
  const { width } = useViewport();
  useHideHeaderOnMobile("order-header", width, 700);
  const { lineItems, PURCHASE_STAGES, purchaseStage, setPurchaseStage, portal } = useContext(buyNowContext);
  const [isCheckoutHeaderStageUnlocked, setIsCheckoutHeaderStageUnlocked] = useState({
    SHIPPING: false,
    PAYMENT: false,
    REVIEW: false
  });

  const onClickHandler = () => {
    const summaryDropMenu=document.querySelector('#summary');
    setShowOrderSummary(!showOrderSummary);
    showOrderSummary ? enableBodyScroll(summaryDropMenu): disableBodyScroll(summaryDropMenu);
  };

  const handleStage = (targetStage) => {
    if (targetStage === PURCHASE_STAGES.SHIPPING && isCheckoutHeaderStageUnlocked.SHIPPING) {
      setPurchaseStage(targetStage);
    } else if (targetStage === PURCHASE_STAGES.PAYMENT && isCheckoutHeaderStageUnlocked.PAYMENT) {
      setPurchaseStage(targetStage);
    } else if (targetStage === PURCHASE_STAGES.REVIEW && isCheckoutHeaderStageUnlocked.REVIEW) {
      setPurchaseStage(targetStage);
    }
  };

  useEffect(() => {
    setIsCheckoutHeaderStageUnlocked({...isCheckoutHeaderStageUnlocked, [purchaseStage]: true})
  }, [purchaseStage]);

  // We want to label the first stage different based on which products are included in the order.
  let firstStageLabel;
  if (lineItems.find(li => li.product.category === PRODUCT_CATEGORIES.SCALE))
    firstStageLabel = "Shipping";
  else if (lineItems.find(li => li.product.category === PRODUCT_CATEGORIES.ADMIN_ACCESS))
    firstStageLabel = "Account";
  else
    firstStageLabel = "Billing";

  return (
    <header id="order-header" className={`container-fluid fixed-top bg-white`}>
      <nav id="order-nav" className='row d-flex align-items-center position-relative py-3'>
        <div className='col-3'>
          <HeaderCompanyLogo portal={portal}/>
        </div>
        <div className='col-6 mt-lg-2 d-flex justify-content-center align-items-center text-center'>
          <div className='d-inline-flex justify-content-center align-items-center w-100'>
            <div className='mx-2 d-flex flex-column justify-content-center align-items-center cursor-pointer'
                 onClick={() => handleStage(PURCHASE_STAGES.SHIPPING)}>
              <div
                className={"d-flex justify-content-center align-items-center " + (isCheckoutHeaderStageUnlocked.SHIPPING ? 'teal-circle' : 'dimmed-circle ')}>
                <span className="header-dot-txt fw-bold">1</span>
              </div>
              <span
                className={"text-capitalize d-none d-lg-block mt-2 header-dot-txt " + (isCheckoutHeaderStageUnlocked.SHIPPING ? 'dark-teal-text' : 'dimmed-text')}>{firstStageLabel}</span>
            </div>
            <div className='mx-2 d-flex flex-column justify-content-center align-items-center cursor-pointer'
                 onClick={() => handleStage(PURCHASE_STAGES.PAYMENT)}>
              <div
                className={"d-flex justify-content-center align-items-center " + (isCheckoutHeaderStageUnlocked.PAYMENT ? 'teal-circle' : 'dimmed-circle ')}>
                <span className="header-dot-txt fw-bold">2</span>
              </div>
              <span
                className={"text-capitalize d-none d-lg-block mt-2 header-dot-txt " + (isCheckoutHeaderStageUnlocked.PAYMENT ? 'dark-teal-text' : 'dimmed-text')}>Payment</span>
            </div>
            <div className='mx-2 d-flex flex-column justify-content-center align-items-center cursor-pointer'
                 onClick={() => handleStage(PURCHASE_STAGES.REVIEW)}>
              <div
                className={"d-flex justify-content-center align-items-center " + (isCheckoutHeaderStageUnlocked.REVIEW ? 'teal-circle' : 'dimmed-circle ')}>
                <span className="header-dot-txt fw-bold">3</span>
              </div>
              <span
                className={"text-capitalize d-none d-lg-block mt-2 header-dot-txt " + (isCheckoutHeaderStageUnlocked.REVIEW ? 'dark-teal-text' : 'dimmed-text')}>Review</span>
            </div>
          </div>
        </div>
        <div className="col-3 dropdown d-lg-none d-flex justify-content-around align-items-center">
          <div
            role="button"
            className='fw-bolder plan-price-txt d-inline me-2 text-nowrap text-dark'
            onClick={onClickHandler}
          >
            ${<TotalPrice/>}
            <i className={"ps-1 fa " + (showOrderSummary ? "fa-chevron-up" : "fa-chevron-down")} style={{ color: "var(--main-color)" }}/>
          </div>
        </div>
      </nav>
      <div className='d-lg-none w-100 position-absolute divider'/>
    </header>
  );
};

CheckoutHeader.prototype = {
  showOrderSummary: PropTypes.bool.isRequired,
  setShowOrderSummary: PropTypes.func.isRequired
};

export default CheckoutHeader